import { render, staticRenderFns } from "./IncomeTaxPolicyView.vue?vue&type=template&id=72d123bc&scoped=true&"
import script from "./IncomeTaxPolicyView.vue?vue&type=script&lang=js&"
export * from "./IncomeTaxPolicyView.vue?vue&type=script&lang=js&"
import style0 from "./IncomeTaxPolicyView.vue?vue&type=style&index=0&id=72d123bc&prod&lang=scss&"
import style1 from "./IncomeTaxPolicyView.vue?vue&type=style&index=1&id=72d123bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d123bc",
  null
  
)

export default component.exports